import axios from '../utils/axios';
import { RunProgress } from '../types/Run';

export async function createRun(data: any): Promise<any> {
  return axios.post('/runs', data).then((res) => res.data);
}

export async function updateRun(runId: string, data: any): Promise<any> {
  return axios.put(`/runs/${runId}`, data).then((res: any) => res.data);
}

export async function deleteRun(runId: string): Promise<any> {
  return axios.delete(`/runs/${runId}`).then((res: any) => res.data);
}

export async function getRun(runId: string, queryString: string): Promise<any> {
  return axios.get(`/runs/${runId}?${queryString}`).then((res) => {
    return res.data;
  });
}

export async function getRuns(queryString: string): Promise<any> {
  return axios.get(`/runs?${queryString}`).then((res) => {
    return res.data;
  });
}

/**
 * Lightweight progress poll for an in-flight reprocess.
 * Hits the dedicated `GET /runs/<id>/progress` endpoint, which returns only the
 * small set of fields needed to drive a progress indicator (no data_static,
 * solve, etc.). Intended to be polled on a short interval while a reprocess is
 * running, then stopped once `data_gridded_pending` is false.
 */
export async function getRunProgress(runId: string): Promise<RunProgress> {
  return axios.get(`/runs/${runId}/progress`).then((res) => res.data);
}

export async function reprocessRuns(data: any): Promise<any> {
  const payload = data.runsToReprocess.map((run: any) => ({
    id: run.id,
    reprocess: true,
  }));

  return axios.put('/runs', payload).then((res: any) => res.data);
}

export async function updateRunsBulk(data: any[]): Promise<any> {
  return axios.put('/runs', data).then((res: any) => res.data);
}
